module.exports = __webpack_public_path__ + "static/img/bg-2.08b725d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-2.png
// module id = +EOi
// module chunks = 85